export const LABELS = ['Orders', 'Samples', 'Visual', 'Sourcing', 'Quote', 'Shipping', 'Accounts', 'General', 'Junk'];

export const LABEL_COLOURS = {
  Orders:   '#1e7a8c',
  Samples:  '#b8822f',
  Visual:   '#8b4a9e',
  Sourcing: '#4a7a3e',
  Quote:    '#3658a0',
  Shipping: '#a04f2a',
  Accounts: '#2d5a3d',
  General:  '#666e7a',
  Junk:     '#a43f3f',
};
